import { MARKETPLACE_HOURLY_RATE } from 'constants/endpoints';
import { METHOD_POST } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_POST_selectedMarketplaceCommunitiesHourlyRate = ({
  marketplaceCommunityIds,
  positionId,
  shiftLength,
}: {
  marketplaceCommunityIds: number[];
  positionId: number;
  shiftLength: number;
}): ApiRequestConfigType => ({
  __typename: 'LegacyAPI',
  method: METHOD_POST,
  url: MARKETPLACE_HOURLY_RATE(),
  body: {
    community_ids: marketplaceCommunityIds,
    position_id: positionId,
    shift_length: shiftLength,
  },
});
